import { BaseModel } from '@shared/base.model';
import { VERIFICATION_SUBMISSION_REQUIREMENT } from './verification-submission-requirement.enum';

/**
 * Policy carried under the `CONNECTIONS_SUBMISSION_POLICY` program rule.
 *
 * The platform default lives in this constructor, same reasoning as `ConnectionsWizardSettings`:
 * `GET .../rules/CONNECTIONS_SUBMISSION_POLICY` returns `null` for every program that has never saved
 * this policy -- which is all of them today -- so the defaulting path here is the normal one, not an
 * edge case. Defaults to OPTIONAL, the opposite of the wizard's REQUIRED default: that is today's actual
 * behavior, where verifying a connection has no bearing on whether it can be submitted.
 */
export class ConnectionsSubmissionPolicy extends BaseModel<ConnectionsSubmissionPolicy> {
  verificationSubmissionRequirement: VERIFICATION_SUBMISSION_REQUIREMENT;

  constructor(policy?: any) {
    super();
    this.verificationSubmissionRequirement =
      policy?.verificationSubmissionRequirement ?? VERIFICATION_SUBMISSION_REQUIREMENT.OPTIONAL;
  }
}
